import type { IFeneTechListQuoteData } from "common/records/FeneTechListQuoteRecord";
import type { IFeneTechQuoteFullData } from "common/records/FeneTechQuoteFullRecord";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const SET_FENETECH_LOADING = "@fenetech/SET_LOADING";
export const RECEIVE_FENETECH_QUOTES = "@fenetech/RECEIVE_QUOTES";
export const RECEIVE_FENETECH_QUOTE = "@fenetech/RECEIVE_QUOTE";
export const RESET_FENETECH_STATE = "@fenetech/RESET_STATE";
export const OPEN_FENETECH_MODAL = "@fenetech/OPEN_MODAL";

export const FeneTechActions = {
  setLoading: (loading: boolean) => createAction(SET_FENETECH_LOADING, loading),
  receiveQuotes: (quotes: IFeneTechListQuoteData[]) => createAction(RECEIVE_FENETECH_QUOTES, quotes),
  receiveQuoteFull: (quote: IFeneTechQuoteFullData) => createAction(RECEIVE_FENETECH_QUOTE, quote),
  resetState: () => createAction(RESET_FENETECH_STATE),
  openModal: (payload: { manufacturerId: string | null; estimateGroupId: number }) =>
    createAction(OPEN_FENETECH_MODAL, payload),
};

export type FeneTechActions = ActionsUnion<typeof FeneTechActions>;
